import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export const SessionExpiredRedirect = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('auth');
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) return;
    hasRedirected.current = true;

    toast.info(t('session_expired'));
    navigate('/', { replace: true });
  }, [navigate, t]);

  return null;
};
